// src/Pages/ServicesPage/ServicesPage.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BackendLink, HeaderOfPages, MiniContainer, SecondaryBtn, DynamicTitle } from '../../Components';
import './ServicesPage.css';

const ServicesPage = () => {
    const { ServiceId } = useParams();
    const [service, setService] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServiceData = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllServices/`);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const data = await response.json();
                const foundService = data.find(item => item.id.toString() === ServiceId);
                setService(foundService);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchServiceData();
    }, [ServiceId]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!service) return <div>Service not found</div>;

    return (
        <div className='service-page'>
            {/* ✅ هنا بنضيف DynamicTitle مع اسم الخدمة */}
            <DynamicTitle customTitle={service.serviceData.title} />

            <HeaderOfPages
                contImg={service.bgImg}
                altImg={service.serviceData.title}
                title={service.serviceData.title}
            />
            <MiniContainer>
                <div className="servicePage-content" data-aos="fade-up" data-aos-duration="1500">
                    {service.serviceData.subTitle && (
                        <h2 className='service-subTitle'>{service.serviceData.subTitle}</h2>
                    )}
                    <div className="para-container">
                        <p className='service-paragraph'>{service.serviceData.paragraph}</p>
                        <ul className='all-points'>
                            {service.serviceData.points && (
                                Object.values(service.serviceData.points).map((point, index) => (
                                    <li
                                        key={index}
                                        className='point'
                                        data-aos="fade-right"
                                        data-aos-delay={`${index}00`}
                                    >
                                        <div className='point-icon'></div>
                                        {point}
                                    </li>
                                ))
                            )}
                        </ul>
                        {service.serviceData.title === "Training Services" && (
                            <div className="mt-5">
                                <SecondaryBtn path="/Training">
                                    Show More Details
                                </SecondaryBtn>
                            </div>
                        )}
                    </div>
                </div>
            </MiniContainer>
        </div>
    );
};

export default ServicesPage;
